export const GTM_EVENTS = {
  // Landing Page
  LANDING_LOGIN: 'landing::content:cta:login',

  // Login Page
  LOGIN_SUBMIT: 'login::content:cta:submit',

  // Home Page
  HOME_VEHICLE_HEALTH: 'home::content:vehicle-health',
  HOME_FUEL_BATTERY_LEVEL: 'home::content:fuel-battery-level',
  HOME_OIL_LIFE: 'home::content:oil-life',
  HOME_TIRE_PRESSURE: 'home::content:tire-pressure',
  HOME_MAP_CLICK: 'home::content:cta:map',
  HOME_SOLUTIONS_FAN_CREATE: 'home:content::solutions:fan::create',
  HOME_SOLUTIONS_ELIGIBILITY_CHECK: 'home:content::solutions:eligibility::check',
  HOME_SOLUTIONS_OTA_MANAGEMENT: 'home:content::solutions:ota::manage',

  // Vehicle Page
  VEHICLE_SEARCH: 'vehicle:content::search::{query}',
  VEHICLE_FILTER: 'vehicle:content::filter::{filter}',
  VEHICLE_DETAILS: 'vehicle:content::detail::{make}:{model}',
  VEHICLE_COUNTER: 'vehicle:content::vehicle-counter',

  // Vehicle Details Page
  VEHICLE_DETAILS_KPI_FUEL_LEVEL: 'vehicle-details::content:fuel-level',
  VEHICLE_DETAILS_KPI_BATTERY_LEVEL: 'vehicle-details::content:battery-level',
  VEHICLE_DETAILS_KPI_OIL_LIFE: 'vehicle-details::content:oil-life',
  VEHICLE_DETAILS_KPI_TIRE_PRESSURE: 'vehicle-details::content:tire-pressure',
  VEHICLE_DETAILS_KPI_ODOMETER: 'vehicle-details::content:odometer',
  VEHICLE_DETAILS_VHR_REPORT: 'vehicle-details::content:vhr-report',
  VEHICLE_DETAILS_TOGGLE: 'vehicle-details::content:select:{value}',

  // VHR Page
  VHR_PRINT: 'vhr::content:print::{document}',
  VHR_DEFINITION: 'vhr::content:definition::{indicator}',

  // Driving Alerts Page
  DRIVING_ALERTS_INFO_SPEED_ALERT: 'driving-alerts::content:information::{label}',
  DRIVING_ALERTS_INFO_CURFEW_ALERT: 'driving-alerts::content:information::{label}',
  DRIVING_ALERTS_INFO_BOUNDARY_ALERT: 'driving-alerts::content:information::{label}',
  DRIVING_ALERTS_INFO_VALET_ALERT: 'driving-alerts::content:information::{label}',
  DRIVING_ALERTS_CREATE: 'driving-alerts::content:::{alert}:{action}',
  DRIVING_ALERTS_SEARCH: 'driving-alerts:content::search::{query}',

  // Product Page
  PRODUCT_CTA: 'product:content::{product}::{action}',

  // Product Description Page
  PRODUCT_DESC_TAB: 'product-description:content::tab-{tab}',
  PRODUCT_DESC_PRICING: 'product-description:content::select::{pricing}',
  PRODUCT_DESC_SELECT_VEHICLES: 'product-description:content::cta::{label}',
  PRODUCT_DESC_SEE_MORE: 'product-description:content::{card}::see-more',
  PRODUCT_DESC_SELECT: 'product-description:content::select::{selection}',
  PRODUCT_DESC_RENEW: 'product-description:content::cta::renew',

  // Solutions Page
  SOLUTIONS_DISCOVER: 'solutions::content::discover',
  SOLUTIONS_CTA_VEHICLE_CAPABILITY: 'solutions::content::vehicle-capability::check',
  SOLUTIONS_CTA_FAN: 'solutions::content::fan::create',
  SOLUTIONS_CTA_OTA: 'solutions::content::ota::enter',
  SOLUTIONS_SEARCH: 'solutions::content::search::{query}',
  SOLUTIONS_CHECK: 'solutions::content::{label}',
  SOLUTIONS_UPLOAD: 'solutions::content::upload',
  SOLUTIONS_FAQ: 'solutions::content::faq::{question}',

  // Payment Page
  PAYMENT_PRICING: 'paiement:content::select::{pricing}',
  PAYMENT_REMOVE: 'paiement:content::remove::{vehicle}',
  PAYMENT_PROMO: 'paiement:content::promo::{code}',
  PAYMENT_CONTINUE: 'paiement:content::{step}::continue',

  // Accounts Page
  ACCOUNTS_CTA: 'accounts::content::{section}::{action}',
  ACCOUNTS_PRIVACY: 'accounts::content::privacy::{policy}',
  ACCOUNTS_UNITS: 'accounts::content::website-preferences::{units}',
  ACCOUNTS_PAYMENT: 'accounts::content::paiement-methode::{action}',
  ACCOUNTS_SECURITY: 'accounts::content::security-pin::{action}',
  ACCOUNTS_SETTINGS: 'accounts::content::::{section}::{toggle}',
  ACCOUNTS_TIME: 'accounts::content::select::{time}',
  ACCOUNTS_TIME_CTA_DISABLE_THEFT: 'accounts::content::vehicle-disable-theft-alarm::{time}::{label}',

  // Global Navigation
  HEADER_CLICK: 'top-nav::{label}',
  FOOTER_CLICK: 'bottom-nav::{section}::{label}',
  FOOTER_SOCIAL: 'bottom-nav::social::{network}'
};
